import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '@material/material.module';

import { MaterialModalComponent } from './material-modal.component';

@NgModule({
  declarations: [MaterialModalComponent],
  imports: [CommonModule, MaterialModule, RouterModule],
  exports: [MaterialModalComponent]
})
export class MaterialModalModule {}
